import { withStyles } from '@material-ui/core';
import Label from './common/Label';
import Value from './common/Value';

const styles = (theme) => ({
  container: {
    margin: '16px 0px'
  },
  value: {
    marginRight: 16
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 8
  },
  accessorialValueContainer: {
    marginLeft: 0,
    marginRight: 8,
    padding: 8,
    marginBottom: 6,
    backgroundColor: theme.radioLabel,
    fontSize: theme.headerTextFontSize,
    fontWeight: 400,
    color: theme.radioLabelText
  }
});

const AccessorialValue = withStyles(styles)(({ value, classes }) => {
  return value ? <div className={classes.accessorialValueContainer}>{value}</div> : null;
});

const Accessorial = ({
  classes,
  selectedAccessorials,
  selectedLimitedAccessCode,
  accessorialList,
  limitedAccessList,
}) => {
  const getLimitedAccessDetail = () => {
    const limitedAccessDetails = limitedAccessList.find(
      (limitedAccess) => limitedAccess.value === selectedLimitedAccessCode
    );
    return `${limitedAccessDetails.value} (${limitedAccessDetails.label})`;
  };
  return (
    <div className={classes.container}>
      <Label labelText="Accessorial" />
      <div className={classes.valueContainer}>
        {selectedAccessorials?.length > 0 && accessorialList?.length > 0 ? (
          <>
            {selectedAccessorials.map((accessorial) => {
              const matchedAccessorial = accessorialList.find((a) => a.name === accessorial);
              if (matchedAccessorial) {
                return <AccessorialValue value={matchedAccessorial.labelText} />;
              }
            })}
            {selectedLimitedAccessCode && <AccessorialValue value={getLimitedAccessDetail()} />}
          </>
        ) : (
          <Value value="NA" />
        )}
      </div>
    </div>
  );
};

export default withStyles(styles)(Accessorial);
